/*
import {
  ht,
  cr,
  a,
  BoxC,
  LblC,
  MsgC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as LblC from "./_cccLblC";
import * as MsgC from "./_cccMsgC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  return (

    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a('dwx/120 fd/csc mh/a'),
      oClds: [

        cr.c(LblC.N, {
          key: -10,
          boxStlz: a(`mb/3`),
          lblCz: {
            boxStlz: a(`dw/f fd/rcc mb/2`),
            textz: {
              pfx:
                '登録手続きが完了しました',
              stlz: a(`tb ts/l`),
            }
          },
          cttCz: {
            boxStlz: a(`dw/f fd/csc`),
            oClds: [

              pz.sPz.crt.ctt == 'i' ?
                cr.c(MsgC.N, {
                  key: -10,
                  boxStlz: a(`dwx/100`),
                  cz: {
                    ls: [
                      {
                        mkrCz: {
                          textz: {
                            pfx: '・',
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: 'ブラウザを閉じて終了してください。',
                          }
                        }
                      },
                    ]
                  }
                })
                : null,

              pz.sPz.crt.ctt == 'i' ?
                cr.c(MsgC.N, {
                  key: -20,
                  boxStlz: a(`dwx/100 mb/2 p/2`),
                  cz: {
                    ls: [
                      {
                        mkrCz: {
                          textz: {
                            pfx: '※',
                            //stlz: a('ts/s'),
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: '正常にメールアドレスの登録が完了すると、【メールアドレス登録のご連絡】というタイトルの確認メールが5分以内に自動で届きます。',
                            //stlz: a('ts/s'),
                          }
                        }
                      },
                      {
                        mkrCz: {
                          textz: {
                            pfx: '※',
                            //stlz: a('ts/s'),
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: '上記のメールが届かなかった場合、メールアドレスが正しく登録されていない可能性がございます。その場合は、もう一度最初から、お試しください。',
                            //stlz: a('ts/s'),
                          }
                        }
                      },
                      {
                        mkrCz: {
                          textz: {
                            pfx: '※',
                            //stlz: a('ts/s'),
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: 'メールが届かない場合、迷惑メール防止サービスをご利用されているお客様は、迷惑メールとして判定されていないかのご確認をお願いします。PCからのメールを拒否されており、ドメイン単位での受信許可が可能な方は「f-supportsys2.com」から届くメールの受信許可設定をお願いいたします。',
                            //stlz: a('ts/s'),
                          }
                        }
                      },
                      {
                        mkrCz: {
                          textz: {
                            pfx: '※',
                            //stlz: a('ts/s'),
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: '何度試してもメールアドレスがうまく登録されない場合は、お手数ですが窓口までご相談ください。',
                            //stlz: a('ts/s'),
                          }
                        }
                      }
                    ]
                  }
                })
                : null,

            ]
          }


        }),

      ]
    })

  );
};
